import { linkButtonPrimary } from '../typography/index'
import Bing from '../../shared/tracking/bing'

import ExternalLink from '../common/externalLink'

import './gift-texts.sass'

const scrollToForm = () => {
  const formElement = document.querySelector('.form')

  formElement.scrollIntoView({ behavior: 'smooth' })
}

// some custom header texts for special promocodes
const isContentB = (code) => {
  const codes = ['WELCOMEGNBGXOB', 'WELCOMEGBXOB']
  return codes.includes(code)
}

const isContentC = (code) => {
  const codes = [
    'WELCOMEGPP',
    'WELCOMEGCH',
    'WELCOMEGPJ',
    'WELCOMEGJM',
    // 'WELCOMEGPF',
    'WELCOMEGJS',
    'WELCOMEGXOJET',
    'WELCOMEGFLYXO',
    'WELCOMEGBDB',
    'WELCOMEGNBDB',
    'WELCOMEGNBCDB',
    'WELCOMEGBUK',
    'WELCOMEGNBUK',
    'WELCOMEGNBCUK',
    'WELCOMEFBDB',
    'WELCOMEGNBMENA',
    'WELCOMEFBUK',
    'WELCOMEFBUSA',
  ]
  return codes.includes(code)
}

const isArabicContentC = (code) => {
  const codes = ['WELCOMEFBDB', 'WELCOMEGNBMENA']
  return codes.includes(code)
}

const isContentD = (code) => {
  const codes = ['WELCOMEGFLGEO']
  return codes.includes(code)
}

const isContentE = (code) => {
  const codes = ['MOTORWORKS', 'FOUNDERSCARD-2021', 'HERMITAGE-2021']
  return codes.includes(code)
}

const isContentGEO = (code) => {
  const codes = {
    WELCOMEFBNYGEO: 'New York',
    WELCOMEFBCAGEO: 'California',
    WELCOMEGNYGEO: 'New York',
    WELCOMEGCAGEO: 'California',
    WELCOMEFBUKGEO: 'London',
    WELCOMEGUKGEO: 'London',
  }
  return codes[code]
}

// —————REFERRAL—————
// first screen content for signup form state for user with referral code
const welcomeReferral = () => {
  return (
    <div>
      <h1 className="h1 mb-3 signup">Welcome Aboard!</h1>
      <p className="fw-4 mb-3">Join NOW!</p>
      <p className="fw-2 mb-2">Membership has its privileges including:</p>
      <div className="fw-2 mb-3">
        <ul>
          <li>
            • Save a&nbsp;Minimum of&nbsp;$250/Seat Per Hour On&nbsp;Guaranteed Shared Flights
          </li>
          <li>• Guaranteed Rates and Availability on&nbsp;Charters</li>
          <li>• Flight Rewards and Loyalty Credits</li>
          <li>• Book Empty Legs and Last Minute Deals</li>
          <li>• 24/7 Support</li>
        </ul>
      </div>
      <p className="fw-4 mb-3">
        Sign Up&nbsp;Now and choose the plan that&rsquo;s right for you. If&nbsp;you purchase
        a&nbsp;Select Access membership that does not require a&nbsp;deposit, enjoy $500
        in&nbsp;Flight Credit. For purchases of&nbsp;all other membership tiers, enjoy $1,000
        in&nbsp;Flight Credits.
      </p>
      <div className="content-footer mobile">
        <div>
          This offer may be&nbsp;discontinued at&nbsp;any time. New members who are referred must
          purchase an&nbsp;XO membership within thirty days of&nbsp;receiving the referral code.
          Only one Flight Credit reward may be&nbsp;redeemed for each referral that results
          in&nbsp;the purchase of&nbsp;a&nbsp;group membership. Membership is&nbsp;subject
          to&nbsp;the terms of&nbsp;the applicable membership Program Agreement. XO&nbsp;reserves
          the right to&nbsp;change, suspend or&nbsp;terminate any of&nbsp;the benefits at&nbsp;any
          time. Utilization of&nbsp;Loyalty and Flight Credits is&nbsp;subject to&nbsp;XO&rsquo;s
          Credit Utilization Policy available at&nbsp;flyxo.com. XO&nbsp;is&nbsp;a&nbsp;foreign air
          charter broker. It&nbsp;is&nbsp;not a&nbsp;direct air carrier and does not operate any
          aircraft. All flights will be&nbsp;operated by&nbsp;properly licensed air carriers
          or&nbsp;foreign air carriers. Fla. Seller of&nbsp;Travel Ref. No. ST42114.
        </div>
      </div>
    </div>
  )
}

// first screen content for login formstate for user with referral code
const loginReferral = () => {
  return (
    <div>
      <h1 className="h1 mb-3 signup">Welcome Aboard!</h1>
      <p className="fw-4 mb-3">Join NOW!</p>
      <p className="fw-2 mb-2">Membership has its privileges including:</p>
      <div className="fw-2 mb-3">
        <ul>
          <li>
            • Save a&nbsp;Minimum of&nbsp;$250/Seat Per Hour On&nbsp;Guaranteed Shared Flights
          </li>
          <li>• Guaranteed Rates and Availability on&nbsp;Charters</li>
          <li>• Flight Rewards and Loyalty Credits</li>
          <li>• Book Empty Legs and Last Minute Deals</li>
          <li>• 24/7 Support</li>
        </ul>
      </div>
      <p className="fw-4 mb-3">
        Log In&nbsp;Now and choose the plan that&rsquo;s right for you. If&nbsp;you purchase
        a&nbsp;Select Access membership that does not require a&nbsp;deposit, enjoy $500
        in&nbsp;Flight Credit. For purchases of&nbsp;all other membership tiers, enjoy $1,000
        in&nbsp;Flight Credits.
      </p>
      <div className="content-footer mobile">
        <div>
          This offer may be&nbsp;discontinued at&nbsp;any time. New members who are referred must
          purchase an&nbsp;XO membership within thirty days of&nbsp;receiving the referral code.
          Only one Flight Credit reward may be&nbsp;redeemed for each referral that results
          in&nbsp;the purchase of&nbsp;a&nbsp;group membership. Membership is&nbsp;subject
          to&nbsp;the terms of&nbsp;the applicable membership Program Agreement. XO&nbsp;reserves
          the right to&nbsp;change, suspend or&nbsp;terminate any of&nbsp;the benefits at&nbsp;any
          time. Utilization of&nbsp;Loyalty and Flight Credits is&nbsp;subject to&nbsp;XO&rsquo;s
          Credit Utilization Policy available at&nbsp;flyxo.com. XO&nbsp;is&nbsp;a&nbsp;foreign air
          charter broker. It&nbsp;is&nbsp;not a&nbsp;direct air carrier and does not operate any
          aircraft. All flights will be&nbsp;operated by&nbsp;properly licensed air carriers
          or&nbsp;foreign air carriers. Fla. Seller of&nbsp;Travel Ref. No. ST42114.
        </div>
      </div>
    </div>
  )
}
// last screen content for user with referral code
const doneReferral = () => {
  return (
    <div>
      <div>
        <h1 className="h1 mb-3 done">Congrats!</h1>
      </div>
      <div className="fw-2 mb-2">
        <p>
          Thank you for joining XO! If&nbsp;you purchase a&nbsp;Select Access membership that does
          not require a&nbsp;deposit, enjoy $500 in&nbsp;Flight Credit. For purchases of&nbsp;all
          other membership tiers, enjoy $1,000 in&nbsp;Flight Credits.
        </p>
        {linkButtonPrimary(
          {},
          <a
            key="done-ref-button"
            href="https://flyxo.com/membership"
            className="done-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
        )}
      </div>
      <div className="fw-2 mb-3">
        <p className="fw-2 mb-3">
          Or talk to one of our Aviation Advisors:
          <br />
          <a href="tel:+188880FLYXO" className="done-link">
            +1-888-80-FLY-XO
          </a>
        </p>
      </div>
    </div>
  )
}
// legal description for referral
const legalReferral = () => {
  return (
    <div>
      This offer may be&nbsp;discontinued at&nbsp;any time. New members who are referred must
      purchase an&nbsp;XO membership within thirty days of&nbsp;receiving the referral code. Only
      one Flight Credit reward may be&nbsp;redeemed for each referral that results in&nbsp;the
      purchase of&nbsp;a&nbsp;group membership. Membership is&nbsp;subject to&nbsp;the terms
      of&nbsp;the applicable membership Program Agreement. XO&nbsp;reserves the right
      to&nbsp;change, suspend or&nbsp;terminate any of&nbsp;the benefits at&nbsp;any time.
      Utilization of&nbsp;Loyalty and Flight Credits is&nbsp;subject to&nbsp;XO&rsquo;s Credit
      Utilization Policy available at&nbsp;flyxo.com. XO&nbsp;is&nbsp;a&nbsp;foreign air charter
      broker. It&nbsp;is&nbsp;not a&nbsp;direct air carrier and does not operate any aircraft. All
      flights will be&nbsp;operated by&nbsp;properly licensed air carriers or&nbsp;foreign air
      carriers. Fla. Seller of&nbsp;Travel Ref. No. ST42114.
    </div>
  )
}

// —————RISE—————

const welcomeRise = () => {
  return (
    <div>
      <h1 className="h1 mb-2 signup">
        Take the private skies once again…with our <br />
        <span style={{ color: '#D8353B' }}>free RISE Experience</span> <br />
        via this simple activation
      </h1>
      <p className="fw-5 mb-2">
        You Were A Member Once. Recapture The Feeling With The RISE Experience.
      </p>
      <p className="fw-4 mb-2">You’re a simple step away.</p>
      <p className="fw-4 mb-2">
        Previous JetSmarter members can now enjoy two free months of&nbsp;the RISE Experience. That
        means access to&nbsp;member pricing and the instant satisfaction of&nbsp;our On&nbsp;Demand
        solution. So&nbsp;whether you are creating a&nbsp;charter flight, offering seats
        on&nbsp;your flight, or&nbsp;booking a&nbsp;seat on&nbsp;an&nbsp;existing flight, our RISE
        experience is&nbsp;designed to&nbsp;exceed your every expectation.
      </p>
    </div>
  )
}

const welcomeFounders = () => {
  return (
    <div>
      <h1 className="h1 mb-4 signup">Your FoundersClub membership is rising to a new level.</h1>
      <p className="fw-4 mb-2">
        That's because you now have access to three free months of the XO RISE Experience.
      </p>
      <p className="fw-4 mb-2">
        You'll be dazzled by XO's private aviation options - from full charters to "Fly By the Seat"
        opportunities.
      </p>
      <p className="fw-4 mb-6">
        We think you'll find it to be such an important addition to your FoundersClub lifestyle,
        that you'll want to buy a full-year of the RISE Experience for <b className="fw-5">$595</b>.
      </p>
    </div>
  )
}

const legalRise = () => (
  <div>
    This offer is non-transferrable and must be redeemed on or before 01/31/20. After 60 days from
    activation of your promotional membership (“Promotional Period”), your membership will be
    automatically renewed and your credit card will be charged a{' '}
    <span style={{ fontWeight: 500 }}>$595 annual membership fee</span>. You can cancel at any time
    by sending your cancellation request in writing to CancelRISE@flyxo.com. If you cancel prior to
    expiration of the Promotional Period, you will not be charged annual payments. Cancellations
    received after expiration of the Promotional Period are effective at the at the end of the
    annual billing period. There are no refunds or credits for partial years. Services and benefits
    are subject to additional fees. By enrolling into the trial membership, you accept the terms of
    the XO RISE Membership Agreement. XO Global LLC is a foreign air charter broker. It is not a
    direct air carrier and does not operate any aircraft. All flights will be operated by properly
    licensed air carriers or foreign air carriers. All services are subject to the terms and
    conditions available at www.flyxo.com/legal. Fla. Seller of Travel Ref. No. ST42114.
  </div>
)

const legalFounders = () => (
  <div>
    This offer is non-transferrable. You must be an active FoundersCard member to redeem this offer.
    After 90 days from activation of your promotional membership (“Promotional Period”), your trial
    will automatically time out. If you would like more information about XO Memberships and flight
    services, please contact{' '}
    <a href="mailto:sales.us@flyxo.com" style={{ color: '#D8353B' }}>
      Sales.US@FlyXO.com
    </a>
    . Flight services are subject to additional fees. By enrolling into the trial membership, you
    accept the terms of the XO RISE Membership Agreement. XO Global LLC is a foreign air charter
    broker. It is not a direct air carrier and does not operate any aircraft. All flights will be
    operated by properly licensed US or foreign air carriers. All services are subject to the terms
    and conditions available at{' '}
    <a href="https://flyxo.com/legal" style={{ color: '#D8353B' }} target="_blank" rel="noopener noreferrer">
      www.flyxo.com/legal
    </a>
    . Fla. Seller of Travel Ref. No. ST42114.
  </div>
)

const extrasRise = () => {
  return (
    <div>
      <h2 className="black-box-title">Three ways to fly with XO!</h2>
      <ul className="black-box-list">
        <li className="mb-4">
          <h3 className="black-box-list-title mb-1">Private Charter</h3>
          <p className="black-box-list-text fs-s">
            XO&rsquo;s centralized aviation platform provides On&nbsp;Demand charter access
            to&nbsp;a&nbsp;fleet of&nbsp;116 aircraft owned by&nbsp;our group companies and
            in&nbsp;addition, a&nbsp;worldwide partner network of&nbsp;over 1,500&nbsp;jets,
            covering the full spectrum of&nbsp;cabin classes from light to&nbsp;long-range. Whether
            booking online, on&nbsp;the app, or&nbsp;with your dedicated Aviation Advisor,
            chartering the perfect jet for your mission has never been more seamless.
          </p>
        </li>
        <li className="mb-4">
          <h3 className="black-box-list-title mb-1">Shared Charter</h3>
          <p className="black-box-list-text fs-s">
            Only XO&nbsp;offers members the unique ability to&nbsp;offset the cost
            of&nbsp;a&nbsp;charter by&nbsp;sharing the seats they do&nbsp;not need. You create the
            charter and get flight credits when anyone purchases your extra seats. Flight credits
            can be&nbsp;used to&nbsp;book future flights, extra seats, and more! Anyone (members
            or&nbsp;non-members) can book seats on&nbsp;a&nbsp;Shared Charter.
          </p>
        </li>
        <li>
          <h3 className="black-box-list-title mb-1">Fly by seats</h3>
          <p className="black-box-list-text fs-s">
            Don&rsquo;t need the whole aircraft? If&nbsp;you are ok&nbsp;with sharing, sell seats
            on&nbsp;your charter flights or&nbsp;book a&nbsp;seat on&nbsp;an&nbsp;existing flight.
            Only XO&nbsp;offers our unique sharing model. Simply search our app or&nbsp;website for
            shared flights for where you want to&nbsp;go&nbsp;and when you want to&nbsp;fly. Book
            your seat and experience the perks of&nbsp;flying private for less than you ever thought
            possible. Shared flights are easy to&nbsp;create and free to&nbsp;join.
          </p>
        </li>
      </ul>
    </div>
  )
}

const doneRise = () => {
  return (
    <div key="done">
      <div>
        <h1 className="h1 mb-4 done">Congrats!</h1>
      </div>
      <p className="fw-2 mb-4"> Enjoy your RISE Experience</p>
      {linkButtonPrimary(
        {},
        <a
          key="done-rise-button"
          href="https://flyxo.com"
          onClick={() => {
            Bing.send('bookFlight')
          }}
        >
          Book flight
        </a>
      )}
    </div>
  )
}

// —————PROMO—————
const welcomePromo = (lang, code = '') => {
  if (lang === 'ar' && isArabicContentC(code)) {
    return (
      <div className="content-fit">
        <h1 className="h1 mb-1 arabic">مرحباً بكم</h1>
        <p className="fw-4 mb-1 arabic">شكراً لاستخدامك الرمز الترويجي {code}!</p>
        <p className="fw-2 mb-1 arabic">
          انضم إلى أول تطبيق رقمي للطيران الخاص، حيث يمكنك على الفور حجز رحلاتك على متن طائرة خاصة
          بالكامل أو مقاعد فردية حول العالم
        </p>
        <p className="fw-2 mb-1 arabic">
          اشترك الآن واستمتع بـ ١٠٠٠ دولار
          <br />
          كرصيد ترويجي من رحلات الطيران الخاص.
        </p>
        <p className="fw-4 mb-1 arabic">الاستخدام لمرة واحدة فقط صالحه لمدة ٣٠ يوماً.</p>
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            سجل معنا الان
          </button>
        )}
        <iframe
          width="600"
          height="275"
          title="XO"
          src="https://www.youtube.com/embed/GN1j-ssKrmg?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />

        <div className="content-footer mobile arabic">
          <div>
            {`٤. هذا العرض غير قابل للتحويل و تنتهي صلاحيته بعد ٣٠ يوم من تاريخ التسجيل. قد يتوقف هذا العرض في أي وقت.
يمكن استخدام الرصيد الترويجي الى ١٠٪ من التكلفة الإجمالية لأي رحلة لطائرة كاملة او شراء مقعد على متن رحلة مشتركة .
الحد الأقصى للاستخدام لكل رحلة ١٠٠٠ دولار للأعضاء و ٢٥٠ دولار لغير الأعضاء.
للحصول و استخدام الرصيد الترويجي يجب التسجيل.`}
          </div>
        </div>
      </div>
    )
  }

  if (lang === 'ar') {
    return (
      <div>
        <h1 className="h1 mb-3 arabic">مرحباً بكم</h1>
        <p className="fw-4 arabic">شكراً لاستخدامك الرمز الترويجي {code}!</p>
        <p className="fw-2 mb-3 arabic"></p>
        <p className="fw-2 mb-3 arabic">
          انضم إلى أول تطبيق رقمي للطيران الخاص، حيث يمكنك على الفور حجز رحلاتك على متن طائرة خاصة
          بالكامل أو مقاعد فردية حول العالم
        </p>
        <p className="fw-2 mb-3 arabic">
          اشترك الآن واستمتع بـ ١٠٠٠ دولار
          <br />
          كرصيد ترويجي من رحلات الطيران الخاص.
        </p>
        <p className="fw-4 mb-3 arabic">الاستخدام لمرة واحدة فقط صالحه لمدة ٣٠ يوماً.</p>
        <div className="content-footer mobile arabic">
          <div>
            {`٤. هذا العرض غير قابل للتحويل و تنتهي صلاحيته بعد ٣٠ يوم من تاريخ التسجيل. قد يتوقف هذا العرض في أي وقت.
يمكن استخدام الرصيد الترويجي الى ١٠٪ من التكلفة الإجمالية لأي رحلة لطائرة كاملة او شراء مقعد على متن رحلة مشتركة .
الحد الأقصى للاستخدام لكل رحلة ١٠٠٠ دولار للأعضاء و ٢٥٠ دولار لغير الأعضاء.
للحصول و استخدام الرصيد الترويجي يجب التسجيل.`}
          </div>
        </div>
      </div>
    )
  }

  if (
    [
      'WELCOMEGCOMP',
      'WELCOMEGNJ',
      'WELCOMEGWU',
      'WELCOMEGJSX',
      'WELCOMEGDPJ',
      'WELCOMEGXOJET',
      'WELCOMEGJS',
      'WELCOMEBBXOJET',
      'WELCOMEBBJS',
      'WELCOMEGVJ',
      'WELCOMEBBVJ',
      'WELCOMEFBVJ',
      'WELCOMEBCOMP',
      'WELCOMEBNJ',
      'WELCOMEBWU',
      'WELCOMEBJSX',
      'WELCOMEBDPJ',
      'WELCOMEBPF',
      'WELCOMEGPF',
      'WELCOMEGJP',
      'MMC',
      'WELCOMEOUTBOUND',
      'WELCOMETT',
      'WELCOMEAK',
      'WELCOMEIMPACT',
      'welcomeOutbound',
    ].includes(code)
  )
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          {
            {
              WELCOMEGCOMP: 'Flying with the competition? Fly XO!',
              WELCOMETT: 'Fly private with the global leader',
              WELCOMEAK: 'Fly private with the global leader',
              WELCOMEIMPACT: 'Fly private with the global leader',
              WELCOMEGJP: 'Fly private with the global leader',
              WELCOMEOUTBOUND: 'Fly private with the global leader',
              WELCOMEGNJ: 'Why fly Net Jets? Fly XO!',
              WELCOMEGWU: 'Why fly Wheels Up? Fly XO!',
              WELCOMEGJSX: 'Why fly JetsuiteX? Fly XO!',
              WELCOMEGDPJ: 'Why fly Delta Private Jets? Fly XO!',
              WELCOMEGXOJET: 'XOJET is now XO. Fly XO today!',
              WELCOMEGJS: 'Jetsmarter is now XO. Fly XO today!',
              WELCOMEBBXOJET: 'XOJET is now XO. Fly XO today!',
              WELCOMEBBJS: 'Jetsmarter is now XO. Fly privately today!',
              WELCOMEGVJ: 'XO is part of Vista Global',
              WELCOMEBBVJ: 'XO is part of Vista Global',
              WELCOMEFBVJ: 'XO is part of Vista Global',
              WELCOMEBCOMP: 'Fly With A Competitor? Fly XO',
              WELCOMEBNJ: 'Why Fly NetJets? Fly XO',
              WELCOMEBWU: 'Why Fly Wheels Up? Fly XO',
              WELCOMEBJSX: 'Why Fly JetSuiteX? Fly XO',
              WELCOMEBDPJ: 'Why Fly Delta Private? Fly XO',
              WELCOMEBPF: 'Why Fly PrivateFly? Fly XO',
              WELCOMEGPF: 'Why Fly PrivateFly? Fly XO',
              welcomeOutbound: 'Enjoy a complimentary XO Membership',
              MMC: 'Welcome Monticello Motor Club',
            }[code]
          }
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights and speak with an XO
          Aviation Advisor to learn more about how you can enjoy a free membership.{' '}
          <b className="fw-5">Limited time code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our global community with over 2,100 private aircraft, where you can instantly book
          an entire private charter or individual seat.
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        <iframe
          width="600"
          height="275"
          title="XO"
          src="https://www.youtube.com/embed/a0AeVCA-A-o?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )

  if (['WELCOMEBNBCXO', 'WELCOMEBNBGXO'].includes(code)) {
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          {
            {
              WELCOMEBNBGXO: 'Fly private with the global leader',
              WELCOMEBNBCXO: 'Flying with the competition? Fly XO!',
            }[code]
          }
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights on private jets or
          towards membership fees by signing up now.{' '}
          <b className="fw-5">Limited time code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our global community with over 2,100 private aircraft, where you can instantly book
          an entire private charter or individual seat.
        </p>
        <iframe
          width="600"
          height="275"
          title="XO"
          src="https://www.youtube.com/embed/a0AeVCA-A-o?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )
  }

  if (isContentB(code)) {
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup">Welcome Aboard!</h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1000 in Promo Credit</b> towards flights on private jets by
          signing up now! <b className="fw-5">Limited time promo code {code} applied!</b>
        </p>
        <p className="fw-3 mb-2">
          Join the first digital marketplace for private aviation, where you can instantly book an
          entire charter or single seats on private jets around the world!
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        <div className="black-box mb-3">
          <h2 className="black-box-title">Three ways to fly with XO!</h2>
          <ul className="black-box-list">
            <li className="mb-4">
              <h3 className="black-box-list-title mb-1">Private Charter</h3>
              <p className="black-box-list-text fs-s">The fasted way to start flying XO.</p>
            </li>
            <li className="mb-4">
              <h3 className="black-box-list-title mb-1">Shared Charter</h3>
              <p className="black-box-list-text fs-s">
                Only XO offers members the unique ability of sharing the seats they do not need.
              </p>
            </li>
            <li>
              <h3 className="black-box-list-title mb-1">Fly by seats</h3>
              <p className="black-box-list-text fs-s">
                Don't need the whole aircraft? Join a flight by booking a single seat!
              </p>
            </li>
          </ul>
        </div>
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )
  }

  if (['WELCOMEBBXO'].includes(code))
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          Fly private with the global leader
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights and speak with an XO
          Aviation Advisor to learn more about how you can enjoy a free membership.{' '}
          <b className="fw-5">Limited time code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our global community with over 2,100 private aircraft, where you can instantly book
          an entire private charter or individual seat.
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        {/* <iframe
          width="600"
          height="275"
          title="XO"
          src={
            isArabicContentC(code)
              ? 'https://www.youtube.com/embed/GN1j-ssKrmg?rel=0'
              : 'https://www.youtube.com/embed/a0AeVCA-A-o?rel=0'
          }
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        /> */}
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )

  if (isContentC(code)) {
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          Fly private with the global leader
        </h1>
        {['WELCOMEGFLYXO', 'WELCOMEGCH', 'WELCOMEGFLGEO'].includes(code) ? (
          <>
            <p className="fw-3 mb-2">
              <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights and speak with
              an XO Aviation Advisor to learn more about how you can enjoy a free membership.{' '}
              <b className="fw-5">Limited time code {code} applied.</b>
            </p>
            <p className="fw-3 mb-2">
              Join our global community with over 2,100 private aircraft, where you can instantly
              book an entire private charter or individual seat.
            </p>
          </>
        ) : (
          <>
            <p className="fw-3 mb-2">
              <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights on private jets
              by signing up now. <b className="fw-5">Limited time promo code {code} applied.</b>
            </p>
            <p className="fw-3 mb-2">
              Join our community, where you can instantly book an entire private charter or single
              seats on private jets globally.
            </p>
          </>
        )}
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <iframe
          width="600"
          height="275"
          title="XO"
          src={
            isArabicContentC(code)
              ? 'https://www.youtube.com/embed/GN1j-ssKrmg?rel=0'
              : 'https://www.youtube.com/embed/a0AeVCA-A-o?rel=0'
          }
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )
  }

  if (['WELCOMEFBFLGEO'].includes(code)) {
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          Global private jet service based in Florida
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights and speak with an XO
          Aviation Advisor to learn more about how you can enjoy a free membership.{' '}
          <b className="fw-5">Limited time code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our local community with over 2,100 private aircraft, where you can instantly book an
          entire private charter or individual seat globally.
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <iframe
          width="600"
          height="275"
          title="XO"
          src={'https://www.youtube.com/embed/a0AeVCA-A-o?rel=0'}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )
  }

  if (isContentD(code)) {
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          Global private jet service based in Florida
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights on private jets by
          signing up now. <b className="fw-5">Limited time promo code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our local community, where you can instantly book an entire private charter or single
          seats on private jets globally.
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <iframe
          width="600"
          height="275"
          title="XO"
          src={'https://www.youtube.com/embed/a0AeVCA-A-o?rel=0'}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )
  }

  if (isContentGEO(code)) {
    const city = isContentGEO(code)
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          Welcome aboard {city}
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights and speak with an XO
          Aviation Advisor to learn more about how you can enjoy a free membership.{' '}
          <b className="fw-5">Limited time code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our global community with over 2,100 private aircraft, where you can instantly book
          an entire private charter or individual seat.
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <iframe
          width="600"
          height="275"
          title="XO"
          src={'https://www.youtube.com/embed/a0AeVCA-A-o?rel=0'}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )
  }

  if (['FLYXO'].includes(code))
    return (
      <div className="content-fit">
        <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
          Fly private with the global leader
        </h1>
        <p className="fw-3 mb-2">
          <b className="fw-5">Enjoy $1,000 in promo credits</b> towards flights on private jets or
          towards membership fees by signing up now.{' '}
          <b className="fw-5">Limited time code {code} applied.</b>
        </p>
        <p className="fw-3 mb-2">
          Join our global community with over 2,100 private aircraft, where you can instantly book
          an entire private charter or individual seat.
        </p>
        <p className="fw-3 mb-2">One-Time Use Only. Credits Expire in 30 days.</p>
        <iframe
          width="600"
          height="275"
          title="XO"
          src="https://www.youtube.com/embed/a0AeVCA-A-o?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <div className="content-footer mobile">
          <div>
            This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
            of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
            Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
            whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
            utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
            customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
            must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account
            deposit to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional
            terms may apply. Speak with an&nbsp;Aviation Advisor for full details.
          </div>
        </div>
      </div>
    )

  if (isContentE(code))
    return (
      <div className="content-fit">
        {['FOUNDERSCARD-2021', 'HERMITAGE-2021'].includes(code) ? (
          <>
            <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
              {code === 'FOUNDERSCARD-2021' ? 'FoundersCard' : 'Your The Hermitage Club'} Membership
              has climbed to a new level.
            </h1>
            <p className="fw-3 mb-2">
              You now have access to a complimentary one-year RISE Membership from XO. <br />
              As a{' '}
              <a
                style={{ color: '#d8353b' }}
                href="https://flyxo.com/membership/rise/"
                target="_blank"
                rel="noopener noreferrer"
              >
                RISE Member
              </a>
              , you’ll be able to book seats on shared flights or private charters on demand with
              waived service fees.
            </p>
            <p className="fw-3 mb-2">
              We are confident that after experiencing the tremendous value and flexibility that
              RISE Membership provides, you’ll want to purchase another year for just $595.
            </p>
          </>
        ) : (
          <>
            <h1 className="h1 mb-2 signup" style={{ fontSize: '29px' }}>
              Welcome McCall's Motorworks attendees!
            </h1>
            <p className="fw-3 mb-2">
              <b className="fw-5">Enjoy a complimentary RISE Membership.</b> Speak to an Aviation
              Advisor to learn more. <br />
              <b className="fw-5">Limited time code {code} applied.</b>
            </p>
            <p className="fw-3 mb-2">
              Join our global community with over 2,100 private aircraft, where you can instantly
              book an entire private charter or individual seat.
            </p>
            <p className="fw-3 mb-2">One-Time Use Only. Offer expires on October 31st, 2021</p>
          </>
        )}
        <iframe
          width="600"
          height={['FOUNDERSCARD-2021', 'HERMITAGE-2021'].includes(code) ? '265' : '275'}
          title="XO"
          src="https://www.youtube.com/embed/a0AeVCA-A-o?rel=0"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        {linkButtonPrimary(
          {},
          <button className="mobile-anchor-link" type="button" onClick={scrollToForm}>
            Sign Up Now
          </button>
        )}
        <div className="content-footer mobile">
          <div>
            This offer is for one year of waived RISE Membership Fees, is non-transferrable, and
            must be redeemed by October 31, {['FOUNDERSCARD-2021', 'HERMITAGE-2021'].includes(code) ? '2022' : '2021'}. This offer is not for complimentary air
            transportation, which is subject to additional fees. Membership is subject to the terms
            of the RISE Membership Agreement. The XO brand is comprised of a portfolio of companies,
            including XO Global LLC, XO Assets LLC, and Apollo Jets, LLC. Apollo Jets, LLC is an
            authorized reseller of XO Global LLC products and services. XO Global LLC is an air
            charter broker, not a direct air carrier, and does not operate any aircraft. All ights
            will be operated by properly licensed U.S. or foreign air carriers. All services are
            subject to the terms and conditions available at www.yxo.com/legal. Fla. Seller of
            Travel Ref. No. ST42114.
          </div>
        </div>
      </div>
    )

  // default lang === 'en'
  return (
    <div>
      <h1 className="h1 mb-3 signup">Welcome Aboard!</h1>
      <p className="fw-4">Thank You for Using Promo Code {code}!</p>
      <p className="fw-2 mb-3">
        Join the first digital marketplace for private aviation, where you can instantly book
        an&nbsp;entire charter or&nbsp;single seats on&nbsp;private jets around the world!
      </p>
      <p className="fw-2 mb-3">
        Sign Up NOW and enjoy<span className="fw-4"> $1000</span>
        <br />
        in Promo Credit towards flights.
      </p>
      <p className="fw-4 mb-3">One-Time Use Only. Credits Expire in&nbsp;30&nbsp;days.</p>
      <div className="content-footer mobile">
        <div>
          This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
          of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
          Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any
          whole aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum
          utilization per flight of&nbsp;$1,000 for program members and $250 for non-program
          customers. Registration is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant
          must sign up&nbsp;for a&nbsp;deposit membership and remit an&nbsp;initial account deposit
          to&nbsp;be&nbsp;eligible to&nbsp;redeem complimentary membership. Additional terms may
          apply. Speak with an&nbsp;Aviation Advisor for full details.
        </div>
      </div>
    </div>
  )
}

const loginPromo = (lang, code = '') => {
  if (lang === 'ar') {
    return (
      <div>
        <h1 className="h1 mb-3 signup"> ٢. مرحبا!</h1>
        <p className="fw-2 mb-3">الرصيد الترويجي للأعضاء الجدد فقط.</p>
      </div>
    )
  }

  if (['FOUNDERSCARD-2021', 'HERMITAGE-2021'].includes(code)) {
    return null
  }

  return (
    <div>
      <h1 className="h1 mb-3 signup">Hello!</h1>
      <p className="fw-2 mb-3">Promotional Credits Are For New Members Only.</p>
    </div>
  )
}

const donePromo = (lang, code = '') => {
  if (lang === 'ar') {
    return (
      <div key="done">
        <p className="fw-2 mb-3">
          ٣. استمتع برصيد ترويجي بقيمة ١٠٠٠ دولار نحو رحلتك الأولى
          <br />
          اسرع العرض ساري لمدة ٣٠ يوم فقط
          <br />
          احجز رحلتك الان
        </p>
        {linkButtonPrimary(
          {},
          <a key="done-promo-button-ar" href="https://flyxo.com">
            اضغط هنا
          </a>
        )}
      </div>
    )
  }

  if (isContentE(code)) {
    return (
      <div key="done">
        <div>
          <h1 className="h1 mb-3 done">Congrats!</h1>
        </div>
        <p className="fw-2 mb-3">Enjoy a complimentary RISE Membership.</p>
        {linkButtonPrimary(
          {},
          <a key="done-promo-button" href="https://flyxo.com">
            Book flight
          </a>
        )}
      </div>
    )
  }

  return (
    <div key="done">
      <div>
        <h1 className="h1 mb-3 done">Congrats!</h1>
      </div>
      <p className="fw-2 mb-3">
        Enjoy $1000 in Promo Credit
        <br />
        towards your first flight.
        <br />
        Hurry up, it’s expires in 30 days
      </p>
      {linkButtonPrimary(
        {},
        <a key="done-promo-button" href="https://flyxo.com">
          Book flight
        </a>
      )}
    </div>
  )
}

const legalPromo = (lang, code = '') => {
  if (lang === 'ar') {
    return (
      <div className="arabic">
        {`٤. هذا العرض غير قابل للتحويل و تنتهي صلاحيته بعد ٣٠ يوم من تاريخ التسجيل. قد يتوقف هذا العرض في أي وقت.
يمكن استخدام الرصيد الترويجي الى ١٠٪ من التكلفة الإجمالية لأي رحلة لطائرة كاملة او شراء مقعد على متن رحلة مشتركة .
الحد الأقصى للاستخدام لكل رحلة ١٠٠٠ دولار للأعضاء و ٢٥٠ دولار لغير الأعضاء.
للحصول و استخدام الرصيد الترويجي يجب التسجيل.`}
      </div>
    )
  }

  if (isContentE(code)) {
    return (
      <div>
        This offer is for one year of waived RISE Membership Fees, is non-transferrable, and must be
        redeemed by October 31, {['FOUNDERSCARD-2021', 'HERMITAGE-2021'].includes(code) ? '2022' : '2021'}. This offer is not for complimentary air transportation, which
        is subject to additional fees. Membership is subject to the terms of the RISE Membership
        Agreement. The XO brand is comprised of a portfolio of companies, including XO Global LLC,
        XO Assets LLC, and Apollo Jets, LLC. Apollo Jets, LLC is an authorized reseller of XO Global
        LLC products and services. XO Global LLC is an air charter broker, not a direct air carrier,
        and does not operate any aircraft. All ights will be operated by properly licensed U.S. or
        foreign air carriers. All services are subject to the terms and conditions available at
        www.yxo.com/legal. Fla. Seller of Travel Ref. No. ST42114.
      </div>
    )
  }

  return (
    <div>
      This offer is&nbsp;non-transferable and expires 30&nbsp;days from the date
      of&nbsp;registration. This offer may be&nbsp;discontinued at&nbsp;any time. Promotional
      Credits may be&nbsp;redeemed for up&nbsp;to&nbsp;10% of&nbsp;the total cost of&nbsp;any whole
      aircraft charter or&nbsp;shared seat purchase subject to&nbsp;a&nbsp;maximum utilization per
      flight of&nbsp;$1,000 for program members and $250 for non-program customers. Registration
      is&nbsp;required to&nbsp;redeem Promotional Credits. Registrant must sign up&nbsp;for
      a&nbsp;deposit membership and remit an&nbsp;initial account deposit to&nbsp;be&nbsp;eligible
      to&nbsp;redeem complimentary membership. Additional terms may apply. Speak with
      an&nbsp;Aviation Advisor for full details.
    </div>
  )
}

const welcomeMmc = () => {
  return (
    <div>
      <h1 className="h1 mb-4 signup">
        Monticello Motor Club Membership rises to a new level with XO.
      </h1>
      <p className="fw-4 mb-2">
        Through our new partnership, Monticello Motor Club Members now have access to XO’s private
        aviation solutions. Monticello Motor Club Members are eligible for a complimentary 1-year
        RISE Membership.
      </p>
      <p className="fw-4 mb-2">
        Each RISE Membership comes with $1,000 of promotional credit, which may be applied to XO
        Membership upgrade fees or up to 10% of flight spend.
      </p>
      <p className="fw-4 mb-2">
        To learn more, please see Offer Terms & Conditions below or contact{' '}
        <ExternalLink to="mailto:mmc@flyxo.com">mmc@flyxo.com</ExternalLink>.
      </p>
    </div>
  )
}

const legalMmc = () => (
  <div>
    <h2 className="mb-3">Offer Terms & Conditions:</h2>

    <h3 className="mb-1">Offer Eligibility:</h3>
    <ul className="bullet-list mb-2">
      <li>No purchase is necessary to redeem this offer.</li>
      <li>
        To redeem this offer, you must be an active Monticello Motor Club Member in good standing
        and not a current XO Member.
      </li>
      <li>This offer is non-transferrable.</li>
      <li>
        In lieu of this offer, active Monticello Motor Club Members who are current XO Select
        Access, Signature Access, or Elite Access Members are eligible to redeem $250 in Loyalty
        Credit. For the avoidance of doubt, current XO Members are not eligible to redeem the XO
        RISE Membership and Promotional Credit.
      </li>
    </ul>

    <h3 className="mb-1">Offer Terms:</h3>
    <ul className="bullet-list">
      <li>
        RISE Membership (new XO Member) or Loyalty Credit (Current XO Member) must be redeemed by
        June 28, 2021.
      </li>
      <li>
        Upon XO RISE Membership activation, Promotional Credit will be credited to Member’s account.
        Promotional Credit is valid for up to 90 days following XO RISE Membership activation and
        may be applied for up to 10% off the total cost of any booked flight, up to a maximum
        discount of $250.
      </li>
      <li>
        However, if Member upgrades to an XO Select Access (Deposit), Signature Access (Deposit) or
        XO Elite Access (Deposit) Membership within 90 days from activation of the XO RISE
        Membership, XO shall convert Member’s remaining Promotional Credit balance to Loyalty
        Credit, which shall remain valid for one year from the date of activation of upgraded
        Membership. Loyalty Credit may be used to offset certain flight costs or up to 100% of
        Membership Fees.
      </li>
      <li>
        Promotional Credit and Loyalty Credit are subject to XO’s{' '}
        <ExternalLink to="https://docs.flyxo.com/legal/general/credit-utilization-policy.html">
          Credit Utilization Policy
        </ExternalLink>
        .
      </li>
      <li>
        XO Memberships are subject to the terms and conditions of the applicable XO Membership
        Agreements.
      </li>
    </ul>
  </div>
)

const disclaimerMmc = () => {
  return (
    <p className="mmc__disclaimer">
      XO Global LLC is a foreign air charter broker. It is not a direct air carrier and does not
      operate any aircraft. All flights will be operated by properly licensed US or foreign air
      carriers. All services are subject to the terms and conditions available at{' '}
      <ExternalLink to="https://flyxo.com/legal/">www.flyxo.com/legal</ExternalLink>. Fla. Seller of
      Travel Ref. No. ST42114.
    </p>
  )
}

const doneMmc = () => {
  return (
    <div key="done">
      <div>
        <h1 className="h1 mb-4 done">Welcome to the RISE experience.</h1>
      </div>
      <p className="fw-2 mb-4">Book flights instantly</p>
      {linkButtonPrimary(
        {},
        <a
          key="done-rise-button"
          href="https://flyxo.com"
          onClick={() => {
            Bing.send('bookFlight')
          }}
        >
          Book flight
        </a>
      )}
    </div>
  )
}

export const content = {
  promo: {
    welcome: welcomePromo,
    login: loginPromo,
    done: donePromo,
    legal: legalPromo,
  },
  referral: {
    welcome: welcomeReferral,
    login: loginReferral,
    done: doneReferral,
    legal: legalReferral,
  },
  rise: {
    welcome: welcomeRise,
    welcomeFounders: welcomeFounders,
    extra: extrasRise,
    done: doneRise,
    legal: legalRise,
    legalFounders: legalFounders,
  },
  mmc: {
    welcome: welcomeMmc,
    legal: legalMmc,
    disclaimer: disclaimerMmc,
    done: doneMmc,
  },
}
